import { FC, MouseEvent, useState } from 'react';
import { useParams } from 'react-router-dom';
import ClassSizeForm from '../ClassSizeForm/ClassSizeForm';
import UnsavedChangesModal from '../../../common/UnsavedChangesModal/UnsavedChangesModal';
import { ClassSizeFormValues } from '../ClassSizeForm/ClassSizeForm.types';
import { SubTitle } from '../../Classes/ClassForm/ClassForm.styles';
import { readOnlyLabelTableText } from '../../../constants/GlobalTexts';

const EditClassSize: FC = () => {
  const { classNo, sizeNo } = useParams();
  const _classNo = classNo as unknown as number;
  const _sizeNo = sizeNo as unknown as number;

  const [formValues, setFormValues] = useState<ClassSizeFormValues>({
    classNo: _classNo,
    sizeNo: _sizeNo,
  });

  const handleSave = (event: MouseEvent) => {
    event.preventDefault();
  };

  return (
    <>
      <ClassSizeForm
        formValues={formValues}
        setFormValues={setFormValues}
        headerTitle={`View Class - ${classNo} | Size - ${sizeNo}`}
        saveDisabled={true}
        handleSave={handleSave}
        isButtonLoading={false}
        isFormReadOnly={true}
        hasImageForm={true}
      />
      <SubTitle>{readOnlyLabelTableText}</SubTitle>
      <UnsavedChangesModal unsavedChangesExist={false} />
    </>
  );
};

export default EditClassSize;